import { useCallback, useReducer } from "react";

export type SelectTagsStepStateType = {
    viewSelected: boolean;
    viewAll: boolean;
};

enum SelectTagsStepActionType {
    viewSelectedChanged = "VIEW_SELECTED_CHANGED",
    viewAllChanged = "VIEW_ALL_CHANGED"
}

type SelectTagsStepAction = {
    type: SelectTagsStepActionType.viewSelectedChanged;
    enabled: boolean;
} | {
    type: SelectTagsStepActionType.viewAllChanged;
    enabled: boolean;
};

const initialState: SelectTagsStepStateType = {
    viewSelected: false,
    viewAll: false
};

function SelectTagsStepReducer(state: SelectTagsStepStateType, action: SelectTagsStepAction): SelectTagsStepStateType {
    switch (action.type) {

        case SelectTagsStepActionType.viewSelectedChanged:
            return {
                ...state,
                viewSelected: action.enabled
            };

        case SelectTagsStepActionType.viewAllChanged:
            return {
                ...state,
                viewAll: action.enabled
            };

        default:
            return state;
    }
}

export type UseSelectTagsStepStateType = {
    state: SelectTagsStepStateType;
    setViewSelected: (viewSelected: boolean) => void;
    setViewAll: (viewAll: boolean) => void;
}

export function useSelectTagsStepState(): UseSelectTagsStepStateType {

    const [state, dispatch] = useReducer(SelectTagsStepReducer, initialState);

    const setViewSelected = useCallback((viewSelected: boolean) => dispatch({
        type: SelectTagsStepActionType.viewSelectedChanged,
        enabled: viewSelected
    }), []);

    const setViewAll = useCallback((viewAll: boolean) => dispatch({
        type: SelectTagsStepActionType.viewAllChanged,
        enabled: viewAll
    }), []);

    return {
        state,
        setViewSelected,
        setViewAll
    };
}
